var styles = {"flexboxPaneContainer":"FlexboxPane-module_flexboxPaneContainer__2o5tp","flexboxPaneChild":"FlexboxPane-module_flexboxPaneChild__DHfvk"};

export { styles as default };
//# sourceMappingURL=FlexboxPane.module.scss.js.map
